(function(){
/* CS: sold-out collection cards - replace Options button with REZ notify button (same slot, same look, single line). */
function fix(){
  var ref=null;
  document.querySelectorAll('product-card').forEach(function(card){
    var rez=card.querySelector('.rez-out-of-stock-collection-btn');
    var qa=card.querySelector('.card__quick-add');
    if(!rez||!qa)return;
    if(rez.parentElement===qa){if(rez.textContent!=='\u{1F514} Notify Me')rez.textContent='\u{1F514} Notify Me';return;}
    if(!ref)ref=document.querySelector('product-card .card__quick-add .btn');
    if(ref){var cs=getComputedStyle(ref);['backgroundColor','color','borderRadius','fontSize','fontWeight','fontFamily','paddingTop','paddingBottom','lineHeight','borderStyle','borderWidth','borderColor'].forEach(function(p){rez.style[p]=cs[p];});}
    rez.style.width='100%';rez.style.margin='0';rez.style.display='block';rez.style.cursor='pointer';
    rez.style.whiteSpace='nowrap';rez.style.overflow='hidden';rez.style.textOverflow='ellipsis';
    rez.textContent='\u{1F514} Notify Me';
    for(var i=0;i<qa.children.length;i++){if(qa.children[i]!==rez)qa.children[i].style.display='none';}
    qa.appendChild(rez);
  });
}
var timer=null;
var mo=new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(fix,250);});
function init(){fix();mo.observe(document.body,{childList:true,subtree:true});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();